export enum MedicalConsultConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'medicalConsult/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'medicalConsult/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_PHYSICIAN = 'medicalConsult/SET_PHYSICIAN',
  SET_OTHER_PHYSICIAN = 'medicalConsult/SET_OTHER_PHYSICIAN',
  SET_METHOD = 'medicalConsult/SET_METHOD',
  SET_FACILITY = 'medicalConsult/SET_FACILITY',
  SAVE_MEDICAL_CONSULT = 'medicalConsult/SAVE_MEDICAL_CONSULT',
  RESET_STATE = 'medicalConsult/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'medicalConsult/SET_ADD_TO_TIMELINE',
  SET_STATE = 'medicalConsult/SET_STATE',
  SET_DATE_TIME = 'medicalConsult/SET_DATE_TIME',
  SET_ASSESSED_BY = 'medicalConsult/SET_ASSESSED_BY',
  ON_SELECT_MEDICAL_CONSULT = 'medicalConsult/ON_SELECT_MEDICAL_CONSULT',
  SET_UPDATE_INPUT_ROWS = 'medicalConsult/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'medicalConsult/SET_DATE',
  SET_TIME = 'medicalConsult/SET_TIME',
  SET_ATTEMPTS = 'medicalConsult/SET_ATTEMPTS',
  SET_SUCCESSFUL_ATTEMPT = 'medicalConsult/SET_SUCCESSFUL_ATTEMPT',
  SET_PTA = 'medicalConsult/SET_PTA',
  SET_COMMENTS = 'medicalConsult/SET_COMMENTS',
  SET_ROLE_PERFORMING = 'medicalConsult/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'medicalConsult/SET_ROLE_PERFORMING_PNNV',
  SET_MEDICAL_CONSULT_DEFAULTS = 'medicalConsult/SET_MEDICAL_CONSULT_DEFAULTS',
}
